export default "/assets/images/app-update-img-04.png?1dbb6d1986056ba85c3c8f50b0d586f0";